import { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getCartAddressPath(locale: Locale): string {
	return getPathInLocale(locale, {
		[Locale.cs]: "/kosik/adresa",
	});
}
